import React from 'react';
import { useNavigate } from "react-router-dom";
import { Release } from "types/release";
import { Table } from "ui-kit/Table";
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { getColumns } from "./columns";

interface TableViewProps {
  data: Release[];
  selected: any[];
  onSelectionChange: (values: any) => void;
  currentPage: number;
  pageCount: number;
  total: number;
  onPageChange?: (event: PaginatorPageChangeEvent) => void;
}

export const TableView: React.FC<TableViewProps> = props => {
  const { data, selected, currentPage, pageCount, total, onSelectionChange, onPageChange } = props;
  const columns = getColumns();
  const navigate = useNavigate();

  const onNavigateByRowClick = (id: string) => navigate(`/releases/${id}`);

  return (
    <Table total={total} pageCount={pageCount} currentPage={currentPage} columns={columns} data={data} selection={selected} onSelectionChange={(e) => onSelectionChange(e.value)} onPageChange={onPageChange} onNavigateByRowClick={onNavigateByRowClick} />
  );
}
